import Vue from "vue"
import { ActionTree, MutationTree } from "vuex"

import resetMixin from "~/mixins/store/resetToInitialState"

import { RootState } from "~/store"
import AgencyKind from "~/types/agencyKind"

const initialState = () => ({
  country: null as string | null,
  entity: "",
  id: 0,
  is_premium: false,
  jobs: [] as number[],
  kind: "" as AgencyKind | "",
  last_excel_export_date: false as boolean | string,
  promo: "",
})
export const state = initialState
export type UserAgencyState = ReturnType<typeof state>

export const mutations: MutationTree<UserAgencyState> = {
  SET: function (state, data: UserAgencyState) {
    const ignoreTypesFor = ["last_excel_export_date", "country"]
    let key: keyof UserAgencyState

    for (key in data) {
      if (
        ignoreTypesFor.includes(key) ||
        typeof state[key] === typeof data[key]
      )
        Vue.set(state, key, data[key])
    }
  },
  ...resetMixin.mutations,
}

export const actions: ActionTree<UserAgencyState, RootState> = {
  FETCH({ dispatch, commit }): Promise<UserAgencyState | void> {
    return new Promise((resolve) => {
      dispatch("GET")
        .then((response: UserAgencyState) => {
          commit("SET", response)
          resolve(response)
        })
        .catch(() => {
          resolve()
        })
    })
  },
  GET(): Promise<UserAgencyState> {
    return this.$axios.$get("/agency/agency/self/")
  },
  LOGOUT({ commit }): void {
    commit("RESET", initialState())
  },
}
